import { css } from 'twin.macro';
import React from 'react';
import { FormPdf } from '../../_elements/FormPdf';
import { PDFViewer } from '@react-pdf/renderer';
import { LoadingSpinner } from '../Loaders';

const FormPdfPreview = React.memo(({ form, hideUnselectedOptions = false, hideInstruction = false }) => {
    return (
        <div
            css={css`
                height: 70vh;
                position: relative;
            `}
        >
            <div
                css={css`
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 1;
                `}
            >
                <LoadingSpinner size={124} />
            </div>

            <PDFViewer
                width="100%"
                height="100%"
                css={css`
                    border: none;
                    outline: none;
                    position: relative;
                    z-index: 2;
                `}
                showToolbar={false}
            >
                {FormPdf(form, 'component', {
                    hideUnselectedOptions,
                    hideInstruction,
                })}
            </PDFViewer>
        </div>
    );
});

export default FormPdfPreview;
